import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class TenantDetailsFormStateMicrosoftPartner extends FormStateBase {

  mpnId: FormFieldState = new FormFieldState();

  constructor() {
    super();
    this.setForm(this);
  }
}
